module.exports = __webpack_public_path__ + "media/images/frontend/edit-fe9cce7893f1f24f29622e4210099a08.svg";